/**
 * The 56px feature icon above the empty-state heading [Figma · `IconFeature56` 11944:15158].
 *
 * Drawn inline rather than exported from the file, for the same reason `Spinner` is: the asset rule in the
 * design-to-code workflow covers *content* — logos, photographs, illustrations — and this is a magnifier
 * glyph on a tinted disc, two primitives the design system already gives us as tokens. An exported SVG would
 * bake `--primary` into a file that stops following the palette.
 *
 * `aria-hidden`, because the heading beneath it says the same thing in words.
 */
export function SearchIcon() {
  return (
    <span className="flex size-14 items-center justify-center rounded-[28px] bg-[var(--primary-muted)]">
      <svg
        aria-hidden="true"
        className="size-6"
        fill="none"
        stroke="var(--primary)"
        strokeLinecap="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <circle cx="11" cy="11" r="7" />
        <path d="M16.5 16.5 21 21" />
      </svg>
    </span>
  );
}
